import { X } from "@phosphor-icons/react";

interface YamlPreviewProps {
	yaml: string;
	open: boolean;
	onClose: () => void;
}

export function YamlPreview({ yaml, open, onClose }: YamlPreviewProps) {
	return (
		<div
			className={`fixed right-0 top-0 z-20 flex h-full w-[420px] flex-col border-l border-border bg-surface shadow-2xl transition-transform duration-300 ${
				open ? "translate-x-0" : "translate-x-full"
			}`}
			style={{ transitionTimingFunction: "var(--forge-ease-out)" }}
		>
			<div className="flex items-center justify-between border-b border-border px-4 py-4">
				<span className="text-xs font-semibold uppercase tracking-widest text-text-muted">
					YAML Preview
				</span>
				<button
					type="button"
					onClick={onClose}
					aria-label="Close YAML preview"
					className="rounded-xl p-1 text-text-muted transition-colors duration-100 hover:bg-accent-bg hover:text-text-primary"
				>
					<X size={16} />
				</button>
			</div>
			<pre className="flex-1 overflow-auto p-4 font-mono text-sm leading-relaxed text-text-primary">
				{yaml}
			</pre>
		</div>
	);
}
